import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import styles from './styles';

interface IndicationSummaryTableProps {
  prevText: string | null;
  currText: string | null;
  // eslint-disable-next-line react/require-default-props
  emptyLabel?: string;
}

const DEFAULT_EMPTY = '—';

const IndicationSummaryTable = ({
  prevText,
  currText,
  emptyLabel = DEFAULT_EMPTY
}: IndicationSummaryTableProps): React.ReactElement => {
  return (
    <TableContainer component={Paper} variant='outlined' sx={styles.tableContainer}>
      <Table size='small' aria-label='Side-by-side comparison' sx={styles.comparisonTable}>
        <TableHead>
          <TableRow sx={styles.tableHeaderRow}>
            <TableCell sx={styles.tableHeaderCellField}>Field / Attribute</TableCell>
            <TableCell sx={styles.tableHeaderCellPrev}>Previous</TableCell>
            <TableCell sx={styles.tableHeaderCellCurr}>Current</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={styles.stubRow}>
            <TableCell component='th' scope='row' sx={styles.stubCell}>
              Indication
            </TableCell>
            <TableCell sx={styles.studyCellPrev}>{prevText ?? emptyLabel}</TableCell>
            <TableCell sx={styles.studyCellCurr}>{currText ?? emptyLabel}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default IndicationSummaryTable;
